export const MAIN_BG_COLOR = 'border';

export const MAIN_TXT_COLOR = 'text-white';

export const BTN_CLS = 'border rounded-sm px-2 py-1 w-full';

export const MAIN_BORDER_COLOR = '#E0E0E0';

export const ROUND_BORDER_COLOR = `rounded-sm border ${MAIN_BORDER_COLOR}`;

export function cx(...inputs: any[]): string {
  const inp = Array.isArray(inputs[0]) ? inputs[0] : [...inputs];
  return inp.filter(Boolean).join(' ');
}
